import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import Img1 from '../Image/Screenshot 2024-06-06 155652.webp';
import Img2 from '../Image/Screenshot 2024-06-06 155702.webp';
import Img3 from '../Image/Screenshot 2024-06-06 155715.webp';
import Img4 from '../Image/Screenshot 2024-06-06 155751.webp';
import Img5 from '../Image/Screenshot 2024-06-06 155808.webp';


const WorksCom = () => {
    const [text, setText] = useState('');
    const fullTextTemplate = 'Here are my mini projects... of course this is not all of them... Hope you like it!';
    const [showGrid, setShowGrid] = useState(false);
    const [isCursorVisible, setIsCursorVisible] = useState(false);
    const [visibleDescriptions, setVisibleDescriptions] = useState({});

    useEffect(() => {
        let index = 0;
        const typingInterval = setInterval(() => {
            if (index < fullTextTemplate.length) {
                setText((prev) => prev + fullTextTemplate[index]);
                index++;
            } else {
                clearInterval(typingInterval);
                setShowGrid(true);
            }
        }, 30);

        return () => clearInterval(typingInterval);
    }, [fullTextTemplate]);

    useEffect(() => {
        const blinkInterval = setInterval(() => {
            setIsCursorVisible((prev) => !prev);
        }, 500);

        return () => clearInterval(blinkInterval);
    }, []);

    const toggleDescription = (project) => {
        setVisibleDescriptions((prev) => ({
            ...prev,
            [project]: !prev[project]
        }));
    };

    return (
        <Container>
            <Title>
                {text}
                {isCursorVisible && '|'}
            </Title>
            <Projects style={{
                display: showGrid ? 'grid' : 'none',
                opacity: showGrid ? 1 : 0,
                transition: 'opacity 0.5s ease'
            }}>
                <ProjectLink target="_blank" href="https://waterpump.uz/">
                    <ProjectImage src={Img2} alt="Water Pump Project"/>
                    <ProjectTitle onClick={() => toggleDescription('waterpump')}>
                        Water Pump Project
                    </ProjectTitle>
                    {visibleDescriptions['waterpump'] && (
                        <ProjectDescription>
                            Description for Water Pump Project.
                        </ProjectDescription>
                    )}
                </ProjectLink>

                <ProjectLink target="_blank" href="https://calculator-by-asad.netlify.app/">
                    <ProjectImage src={Img1} alt="Calculator Project"/>
                    <ProjectTitle onClick={() => toggleDescription('calculator')}>
                        Calculator Project
                    </ProjectTitle>
                    {visibleDescriptions['calculator'] && (
                        <ProjectDescription>
                            Description for Calculator Project.
                        </ProjectDescription>
                    )}
                </ProjectLink>
                <ProjectLink target="_blank" href="https://game-store-by-asad.netlify.app/">
                    <ProjectImage src={Img4} alt="Game Store Project"/>
                    <ProjectTitle onClick={() => toggleDescription('gamestore')}>
                        Game Store Project
                    </ProjectTitle>
                    {visibleDescriptions['gamestore'] && (
                        <ProjectDescription>
                            Description for Game Store Project.
                        </ProjectDescription>
                    )}
                </ProjectLink>
                <ProjectLink target="_blank" href="https://fake-store-by-asad.netlify.app/">
                    <ProjectImage src={Img3} alt="Fake Store Project"/>
                    <ProjectTitle onClick={() => toggleDescription('fakestore')}>
                        Fake Store Project
                    </ProjectTitle>
                    {visibleDescriptions['fakestore'] && (
                        <ProjectDescription>
                            Description for Fake Store Project.
                        </ProjectDescription>
                    )}
                </ProjectLink>
                <ProjectLink target="_blank" href="https://usecard-by-asad.netlify.app/">
                    <ProjectImage src={Img5} alt="UseCard Project"/>
                    <ProjectTitle onClick={() => toggleDescription('usecard')}>
                        Carting Project
                    </ProjectTitle>
                    {visibleDescriptions['usecard'] && (
                        <ProjectDescription>
                            Description for Carting Project.
                        </ProjectDescription>
                    )}
                </ProjectLink>
            </Projects>
        </Container>
    );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
`;

const Title = styled.h1`
  font-family: Consolas, monospace;
  color: #0fff03;
  text-align: left !important;
`;

const Projects = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  margin-top: 100px;
  grid-gap: 10px;
  @media (max-width: 420px){
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 5px;
  }
`;

const ProjectLink = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
  color: #0fff03;
  font-family: Consolas, sans-serif;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
  transition: transform 0.3s, box-shadow 0.3s;
  margin: auto;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

const ProjectImage = styled.img`
  height: auto;
  flex-grow: 1;
  object-fit: cover;
  width: 100%;
`;

const ProjectTitle = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  cursor: pointer;
`;

const ProjectDescription = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  color: #fff;
  padding: 10px;
  width: 100%;
  text-align: center;
  font-size: 12px;
`;

export default WorksCom;
